import React, {
  FC, useContext, useEffect, useMemo, useState,
} from 'react';
import { UserSessionContext } from 'components/UserSession';
import { GraphQLAttendee } from 'network/graphql-models';
import axios from 'axios';
import { LIVESTREAM_API_URL } from 'appenv';
import PictureInPictureBoothLiveStreamContent from 'components/pictureInPicture/PictureInPictureBoothLiveStreamContent';
import { LocalizableString } from 'models/cms/common/types';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { liveStreamActions, liveStreamSelectors } from 'models/liveStream';
import createLiveStreamTokenObservable from 'network/createLiveStreamTokenObservable';
import { useObservable } from 'react-use';
import LiveStreamStatusSubscriber from 'components/pictureInPicture/LiveStreamStatusSubscriber';

export interface PictureInPictureBoothLiveStreamProps {
  boothId: string;
  boothName: LocalizableString;
  className?: string;
  enableHandle?: boolean;
}

const PictureInPictureBoothLiveStream: FC<PictureInPictureBoothLiveStreamProps> = ({
  boothId, boothName, className, enableHandle,
}) => {
  const userSession = useContext(UserSessionContext).userSession as Partial<GraphQLAttendee>;
  const agoraAccount = useMemo(() => userSession.uuid + Math.random(), [userSession.uuid]);

  const liveStreamToken$ = useMemo(() => createLiveStreamTokenObservable(boothId, agoraAccount, 'audience'), [agoraAccount, boothId]);
  const { agoraToken } = useObservable(liveStreamToken$) ?? {};

  const isClosable = useSelector(liveStreamSelectors.selectIsClosable);

  return agoraToken == null ? null : (
    <>
      <LiveStreamStatusSubscriber targetBoothId={boothId} />
      <PictureInPictureBoothLiveStreamContent
        key={boothId}
        boothId={boothId}
        agoraAccount={agoraAccount}
        agoraToken={agoraToken}
        boothName={boothName}
        isClosable={isClosable}
        className={className}
        enableHandle={enableHandle}
      />
    </>
  );
};

export default React.memo(PictureInPictureBoothLiveStream);
